exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alert {\n  align-items: right;\n  animation: .5s ease-in-out 0s 1 light-bounce-in;\n  margin: 1rem 1rem 0 0;\n  max-width: 30rem;\n  position: fixed;\n  right: 0;\n  z-index: 10000; }\n  .alert .alert-body {\n    margin-bottom: 0; }\n\n.close:active, .close:focus {\n  outline: none; }\n\n@keyframes light-bounce-in {\n  0% {\n    opacity: 0;\n    transform: translateY(20%); }\n  50% {\n    transform: translateY(-5%); }\n  100% {\n    opacity: 1;\n    transform: translateY(0%); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/AutoDismissAlert/AutoDismissAlert.scss
// module id = 152
// module chunks = 0